import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNavigationArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "m11.702 18.541 5.095-13.744.004-.012a1.25 1.25 0 0 0-1.599-1.586L1.46 8.297a1.23 1.23 0 0 0-.834 1.178v.023a1.23 1.23 0 0 0 .882 1.172l.016.005 6.093 1.706 1.707 6.094.004.015a1.25 1.25 0 0 0 2.374.049zm-2.975-6.835a.63.63 0 0 0-.433-.433L1.875 9.476l.013-.004 13.737-5.097L10.53 18.11l-.005.012z"
	})
});
export default SvgNavigationArrow;
